import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { UploadProgressService } from '../services/upload-progress.service';

/** Path of the BU PDF bulk-upload endpoints (`EsraPipingAPIClient.createDocumentUpload` and the preview edit calls). */
const TRACKED_UPLOAD_PATH: string = '/api/Document/esra1/';

/** Highest value reported while bytes are still in flight; 100 is reserved for the server response. */
const MAX_IN_FLIGHT_PERCENT: number = 99;

/**
 * Reports upload progress for the BU PDF bulk upload.
 *
 * Only multipart (`FormData`) requests send files worth tracking; JSON calls to the same endpoints are left alone.
 * The NSwag client does not set `reportProgress`, so this clones the request with it enabled.
 * `HttpClient` still filters the stream down to the final response for the generated client,
 * so its response and error handling are unchanged.
 */
@Injectable()
export class UploadProgressInterceptor implements HttpInterceptor {
  constructor(private readonly uploadProgressService: UploadProgressService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isUpload: boolean = (request.method === 'POST' || request.method === 'PUT') && request.body instanceof FormData;
    if (!isUpload || !request.url.includes(TRACKED_UPLOAD_PATH)) {
      return next.handle(request);
    }

    return next.handle(request.clone({ reportProgress: true })).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (event.type === HttpEventType.UploadProgress && event.total) {
          const percent: number = Math.round((100 * event.loaded) / event.total);
          this.uploadProgressService.report(Math.min(percent, MAX_IN_FLIGHT_PERCENT));
        }
      }),
    );
  }
}
